/* esm.sh - unhead@3.4.1/dist/shared/unhead.Bf_fPVYA */
var n=Object.prototype.hasOwnProperty;function o(t,r){return n.call(t,r)}export{o as h};
//# sourceMappingURL=unhead.Bf_fPVYA.mjs.map